import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { SocialMediaCoreDomainNameStringAssets } from "../../../../../assets/stringAssets";

/**
 * @function referenceIsForAFacebookPost Returns whether the socialMediaPostRawReference is for a Facebook Post
 * 
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export const referenceIsForAFacebookPost: (socialMediaPostRawReference: string) => boolean = (socialMediaPostRawReference: string) => {
  // return value (defaulted to 'false') indicating whether the socialMediaPostRawReference matches a known regular expression
  let foundMatchForRawReference: boolean = false;

  // as a quick check, determine whether this social media's core domain name is found withing the raw reference
  if (socialMediaPostRawReference.toLowerCase().search(SocialMediaCoreDomainNameStringAssets.Facebook.toLowerCase()) !== -1) {

    // test for each type of raw reference for this social media type until a match is found or the list of social media types has been exhausted
    if (!foundMatchForRawReference) {
      foundMatchForRawReference = RegularExpressions.FacebookPostEmbedUrl.test(socialMediaPostRawReference);
    }

    if (!foundMatchForRawReference) {
      // some Facebook Post references (eg, an IFrame reference) has and encoded URI for the 'href', so we will URI decode the socialMediaPostRawReference and
      // use that for determining whether the reference is a Facebook Post
      // const socialMediaPostRawReferenceDecoded: string = decodeURI(socialMediaPostRawReference);
      const socialMediaPostRawReferenceDecoded: string = decodeURIComponent(socialMediaPostRawReference);

      foundMatchForRawReference = RegularExpressions.FacebookPostIFrameWithFullSpecs.test(socialMediaPostRawReferenceDecoded);
    }
  }

  // return the result of testing the given socialMediaPostRawReference against the regex pattern(s)
  return foundMatchForRawReference;
}
